import React, { useState } from "react";
import { Card, Spinner, Alert, Form } from "react-bootstrap";
import {
  useGetVendorsQuery,
} from "../slices/userApiSlice"; // Adjust path
import {
useToggleVendorStatusMutation,
} from "../slices/productApiSlice"; // Adjust path

const VendorToggleCard = () => {
  const { data: vendors = [], isLoading: isVendorsLoading, isError: isVendorsError, error: vendorsError } = useGetVendorsQuery();
  const [toggleVendorStatus, { isLoading: isToggling }] = useToggleVendorStatusMutation();

  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const selectedVendor = vendors.find((v) => v._id === selectedVendorId);
  const isActive = selectedVendor?.vendorDetails?.isActive ?? false;

  const handleVendorChange = (e) => {
    setSelectedVendorId(e.target.value);
    setMessage(null);
    setError(null);
  };

  const handleToggle = async () => {
    try {
      setMessage(null);
      setError(null);
      const res = await toggleVendorStatus({
        vendorId: selectedVendorId,
        isActive: !isActive,
      }).unwrap();

      setMessage(res.message || "Vendor status updated successfully");
    } catch (err) {
      setError(
        err?.data?.message || "Failed to update vendor status. Try again."
      );
    }
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title>Toggle Vendor Status</Card.Title>

        {isVendorsLoading ? (
          <Spinner animation="border" />
        ) : isVendorsError ? (
          <Alert variant="danger">
            {vendorsError?.data?.message || "Failed to load vendors"}
          </Alert>
        ) : (
          <>
            <Form.Group controlId="vendorSelect" className="mb-3">
              <Form.Label>Select Vendor</Form.Label>
              <Form.Select
                value={selectedVendorId}
                onChange={handleVendorChange}
              >
                <option value="">-- Choose a Vendor --</option>
                {vendors.map((vendor) => (
                  <option key={vendor._id} value={vendor._id}>
                    {vendor.name} ({vendor.vendorDetails?.shopName || "No Shop"})
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {selectedVendorId && (
              <>
                <Form.Check
                  type="switch"
                  id={`isActive-switch-${selectedVendorId}`}
                  label={isActive ? "Active" : "Inactive"}
                  checked={isActive}
                  onChange={handleToggle}
                  disabled={isToggling}
                />

                {isToggling && (
                  <Spinner animation="border" size="sm" className="mt-2" />
                )}

                {message && (
                  <Alert variant="success" className="mt-2">
                    {message}
                  </Alert>
                )}

                {error && (
                  <Alert variant="danger" className="mt-2">
                    {error}
                  </Alert>
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default VendorToggleCard;
